import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Box, CircularProgress, Container, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import swal from 'sweetalert';
import AfiliadosListResults from '../../components/Afiliados/AfiliadosListResults';
import AfiliadosListToolbar from '../../components/Afiliados/AfiliadosListToolbar';
import affiliateService from '../../services/affiliateService';

const AfiliadosList = () => {
  const auth = useSelector((state) => state.auth);
  const [isLoadingRegs, setIsLoadingRegs] = useState(true);
  const [regs, setRegs] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(25);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [showPendingOnly, setShowPendingOnly] = useState(false);

  const get = async () => {
    setIsLoadingRegs(true);
    setRegs([]);

    try {
      const params = {
        page,
        per_page: perPage
      };

      if (showPendingOnly) {
        params.approved = false;
      }

      const response = await affiliateService.getChannels(auth.token, params);

      if (!response || !response.data) {
        throw new Error('Erro ao buscar canais');
      }

      setRegs(response.data.data || []);
      setPage(response.data.page || 1);
      setPerPage(response.data.perPage || 25);
      setTotal(response.data.total || 0);
    } catch (e) {
      console.error(e);
      swal('Erro', 'Erro ao buscar canais de afiliados', 'error');
    } finally {
      setIsLoadingRegs(false);
    }
  };

  useEffect(() => {
    get();
  }, [page, perPage, showPendingOnly]);

  const handleApprove = async (id) => {
    try {
      const response = await affiliateService.approveChannel(id, auth.token);

      if (response && response.data) {
        swal('Sucesso', 'Canal aprovado com sucesso!', 'success');
        get(); // Recarrega a lista
      } else {
        throw new Error('Erro ao aprovar canal');
      }
    } catch (e) {
      console.error(e);
      swal('Erro', 'Erro ao aprovar canal', 'error');
    }
  };

  const handleReject = async (id) => {
    try {
      const response = await affiliateService.rejectChannel(id, auth.token);

      if (response && response.data) {
        swal('Sucesso', 'Canal rejeitado', 'info');
        get(); // Recarrega a lista
      } else {
        throw new Error('Erro ao rejeitar canal');
      }
    } catch (e) {
      console.error(e);
      swal('Erro', 'Erro ao rejeitar canal', 'error');
    }
  };

  return (
    <>
      <Helmet>
        <title>Afiliados | Sistema de Afiliados</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <AfiliadosListToolbar
            search={search}
            setSearch={setSearch}
            showPendingOnly={showPendingOnly}
            setShowPendingOnly={setShowPendingOnly}
            onRefresh={get}
          />
          {isLoadingRegs && (
            <Box sx={{ pt: 3 }}>
              <Typography align="center" variant="h5" color="primary">
                <CircularProgress color="primary" sx={{ mb: 3 }} />
                <br />
                Buscando informações, por favor aguarde...
              </Typography>
            </Box>
          )}
          {!isLoadingRegs && (!regs || regs.length === 0) && (
            <Box sx={{ pt: 3 }}>
              <Typography align="center" variant="h5" color="primary">
                Nenhum canal localizado
              </Typography>
            </Box>
          )}
          {!isLoadingRegs && regs && regs.length > 0 && (
            <Box sx={{ pt: 3 }}>
              <AfiliadosListResults
                regs={regs}
                setRegs={setRegs}
                page={page}
                setPage={setPage}
                perPage={perPage}
                setPerPage={setPerPage}
                total={total}
                onApprove={handleApprove}
                onReject={handleReject}
                onRefresh={get}
              />
            </Box>
          )}
        </Container>
      </Box>
    </>
  );
};

export default AfiliadosList;
